import { type TOrientation, type TSize } from "@/types/common";
import Skeleton from "../Skeleton";
import {
  StyledProductCardGalleryXLSkeletonRoot,
  StyledSkeletonContent,
  StyledSkeletonContentWrapper,
} from "./styles";

interface ProductCardGalleryXLSkeletonProps {
  orientation?: TOrientation;
  size?: TSize;
}
export const ProductCardGalleryXLSkeleton = ({
  size,
  orientation = "vertical",
}: ProductCardGalleryXLSkeletonProps) => {
  return (
    <StyledProductCardGalleryXLSkeletonRoot $orientation={orientation}>
      <Skeleton
        type="gallery"
        height={orientation === "vertical" ? "302px" : "100%"}
        width={orientation === "vertical" ? "100%" : "40%"}
        withBorder={false}
      />
      <StyledSkeletonContentWrapper tw="w-full">
        <StyledSkeletonContent>
          <Skeleton height="1.563rem" type="text" width="77%" />
          <Skeleton height="1.563rem" type="text" width="30%" />
        </StyledSkeletonContent>
        <Skeleton height="2.25rem" type="button" />
      </StyledSkeletonContentWrapper>
    </StyledProductCardGalleryXLSkeletonRoot>
  );
};
export default ProductCardGalleryXLSkeleton;
